import React, { useState } from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import SignupAgeGateModal from './components/SignupAgeGateModal';
import DisclaimerText from './components/DisclaimerText';
import { authorizationUrlsProps } from './shared/prop-types';

const SignupForm = ({ authorizationUrls, locale }) => {
  const [openModal, setOpenModal] = useState(false);
  const [signupOption, setSignupOption] = useState(null);

  const I18nPrefix = 'strava.landing_page';

  const handleOnClick = (option) => {
    setOpenModal(true);
    setSignupOption(option);
  };

  return (
    <>
      {/** FACEBOOK */}
      <button
        className={`${styles.signupButton} ${styles.facebookSignupButton}`}
        onClick={() => handleOnClick('facebook')}
        variant="primary"
        data-testid="facebook_sign_up_btn"
        type="button"
      >
        {I18n.t(`${I18nPrefix}.here_to_join.facebook_cta`)}
      </button>
      {/** GOOGLE */}
      <button
        className={`${styles.signupButton} ${styles.googleSignupButton}`}
        onClick={() => handleOnClick('google')}
        variant="primary"
        data-testid="google_sign_up_btn"
        type="button"
      >
        {I18n.t(`${I18nPrefix}.here_to_join.google_cta`)}
      </button>

      <div className={styles.hr}>
        <div className={styles.hrText}>{I18n.t(`${I18nPrefix}.or`)}</div>
      </div>

      {/** EMAIL */}
      <button
        className={`${styles.signupButton} ${styles.emailSignupButton}`}
        onClick={() => handleOnClick('email')}
        variant="primary"
        data-testid="email_sign_up_btn"
        type="button"
      >
        {I18n.t(`${I18nPrefix}.here_to_join.email_cta`)}
      </button>

      <DisclaimerText />

      <SignupAgeGateModal
        open={openModal}
        signupOption={signupOption}
        authorizationUrls={authorizationUrls}
        onDismissCallback={() => {
          setOpenModal(false);
        }}
        locale={locale}
      />
    </>
  );
};
SignupForm.propTypes = {
  authorizationUrls: authorizationUrlsProps.isRequired,
  locale: PropTypes.string.isRequired
};

export default SignupForm;
